module.exports = __webpack_public_path__ + "assets/img/c972f0b19b83309bb7b9ca0021878161.a03dff81.png";